/*==========================================================
INCLUDES RESPONSIVE SCRIPTS
==========================================================*/

$(function() {
	/*==========================================================
        I WANT TO MODAL
    ==========================================================*/

    $("[data-modal-id='idLikeToModal']").on('click', function (event) {
        event.preventDefault();
        $('#idLikeToModal').slideToggle(240).addClass('open');
        $('.modal-cover').fadeIn();
		$('body').addClass('modal-open');
        trap_focus($('#idLikeToModal'), 'idLikeToModal');
        $("#idLikeToModal .close").focus();
        return false;
    });

    function closeIdLikeToModal(e) {
        if ($('#idLikeToModal').hasClass('open')) {
            e.stopPropagation();
            $("#idLikeToModal").slideToggle(240).removeClass('open');
            $(".modal-cover").fadeOut();
            $('body').removeClass('modal-open');
            remove_trap_focus($('#idLikeToModal'), 'idLikeToModal');
            $("button[data-modal-id='idLikeToModal'").focus();
        }
    }

    $("#idLikeToModal .close, .modal-cover").on('click', function (e) {
        closeIdLikeToModal(e);
        return false;
    });
    $("#idLikeToModal .close, .modal-cover").on('keydown', function (e) {
        var code = e.keyCode || e.which;
        if (code === 13) { //Enter keycode
            closeIdLikeToModal(e);
            return false;
        }
    });


    // Add events to Flickity prototype
    ['play', 'stop', 'pause', 'unpause'].forEach(function(action) {
        var methodName = action + 'Player';
        Flickity.prototype[methodName] = function() {
            this.player[action]();
            this.dispatchEvent(methodName);
        };
    });
});

function initialiseTopAlert() {
    $('.emergencyBarSlider').flickity({
        adaptiveHeight: false,
        autoPlay: 5000,
        cellAlign: 'left',
        contain: true,
        draggable: true,
        prevNextButtons: true,
        pageDots: true,
        pauseAutoPlayOnHover: true,
        setGallerySize: true,
        wrapAround: true,
        on: {
            ready: function() {
                // Add pause button
                var pause = '<button class="flickity-button pause" type="button"><span class="ic-sr-only">Pause Banner</span></button>';
                $(pause).insertAfter('.emergencyBarSlider .flickity-page-dots');

                $('.emergencyBarSlider .flickity-page-dots .dot').each(function(index){
                    $(this).attr('aria-label', 'Banner ' + (index + 1) );
                });
             }
        }
    });

    $('.emergencyBarSlider .flickity-button.pause').on('click', function() {
        if ($(this).hasClass('paused')) {
            $('.emergencyBarSlider .flickity-button.pause span').text('Pause Banner');
            $('.emergencyBarSlider').flickity('playPlayer');
        } else {
            $('.emergencyBarSlider .flickity-button.pause span').text('Play Banner');
            $('.emergencyBarSlider').flickity('stopPlayer');
        }
        $(this).toggleClass('paused');
    });
    if (!window.matchMedia('(min-width: 1200px').matches) {
        $('.emergencyBarSlider').flickity('stopPlayer');
    }

    $(window).debounceResize(function() {
        if (!window.matchMedia('(min-width: 1200px').matches) {
            $('.emergencyBarSlider').flickity('stopPlayer');
        }
    });
}
